import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showSection
    ? _c(
        "section",
        {
          staticClass: "lpu-phonebook d-flex flex-column",
          class: _setup.isMobile ? "lpu-phonebook--mobile ga-4" : "ga-6",
          attrs: { id: "phonebook", "data-qa": "lpu_phonebook" },
        },
        [
          _c(
            "h2",
            {
              ref: "titleRef",
              staticClass: "text--text ma-0",
              class: _setup.isMobile ? "text-h6" : "text-h5",
              attrs: { "data-qa": "lpu_phonebook_title" },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_setup.tStatic("Телефонный справочник")) +
                  "\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "lpu-phonebook__lists d-flex flex-column",
              class: _setup.isMobile ? "ga-4" : "ga-6",
            },
            [
              _vm._l(_setup.collapsedDepartments, function (department) {
                return _c(_setup.PhonebookDepartment, {
                  key: department.key,
                  attrs: { department: department },
                })
              }),
              _vm._v(" "),
              _c(VExpandTransition, [
                _setup.isExpanded && _setup.expandedDepartments.length
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex flex-column",
                        class: _setup.isMobile ? "ga-4" : "ga-6",
                      },
                      _vm._l(_setup.expandedDepartments, function (department) {
                        return _c(_setup.PhonebookDepartment, {
                          key: department.key,
                          attrs: { department: department },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _setup.hasHiddenDepartments
            ? _c(
                VBtn,
                {
                  staticClass:
                    "lpu-phonebook__toggle branding-btn branding-btn--primary rounded-20 text-subtitle-1 text-none",
                  class: _setup.isMobile ? "w-100" : "align-self-center",
                  attrs: {
                    depressed: "",
                    height: "52",
                    block: _setup.isMobile,
                    "data-qa": "lpu_phonebook_toggle",
                  },
                  on: { click: _setup.toggleExpanded },
                },
                [_vm._v("\n    " + _vm._s(_setup.toggleLabel) + "\n  ")]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }